import { LaneAPI } from '../../../api/datamanager/LaneAPI';

export class LanesDraftCommand {
    get(laneType, edition, successCallback, errorCallback) {
        const apiResult = LaneAPI.list("draft", laneType, edition.draftCounty);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getByProvider(successCallback, errorCallback) {
        const apiResult = LaneAPI.listByProvider("draft");
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(laneType, edition, lane, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if (undefined === lane.id || 0 === lane.id) {
            apiResult = LaneAPI.create("draft", laneType, edition.draftCounty, lane);
            successMessage = "Micro Mobilidade criada com sucesso";
        }
        else {
            apiResult = LaneAPI.update("draft", laneType, edition.draftCounty, lane.id, lane);
            successMessage = "Micro Mobilidade editada com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveByProvider(lane, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if (undefined === lane.id || 0 === lane.id) {
            apiResult = LaneAPI.createByProvider("draft", lane);
            successMessage = "Micro Mobilidade criada com sucesso";
        }
        else {
            apiResult = LaneAPI.updateByProvider("draft", lane.id, lane);
            successMessage = "Micro Mobilidade editada com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(laneType, edition, laneId, successCallback, errorCallback) {
        const apiResult = LaneAPI.delete("draft", laneType, edition.draftCounty, laneId);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Micro Mobilidade eliminada com sucesso",
                    data: undefined
                };
                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

        deleteByProvider(laneId, successCallback, errorCallback) {
        const apiResult = LaneAPI.deleteByProvider("draft", laneId);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Micro Mobilidade eliminada com sucesso",
                    data: undefined
                };
                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
